import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// img
import plusBtn from '../img/menu_ico_plus.png';
import minusBtn from '../img/menu_ico_minus.png';
import menIcon from '../img/menu_ico.png';

class NavManualLinkSub extends React.Component{
    state = {
        id: this.props.linkName,
        btn_state: "plus"
    };
    open_sub(){
        const btn_img = document.getElementById(this.state.id+"_btnImg");
        const sub_div = document.getElementById(this.state.id+"_div");

        if(this.state.btn_state === "plus"){
            btn_img.src = minusBtn;
            this.setState({btn_state:"minus"});
            sub_div.style.display = "block";
        }else{
            btn_img.src = plusBtn;
            this.setState({btn_state:"plus"});
            sub_div.style.display = "none";
        }
    };
    render(){
        const {subList, to, linkName} = this.props;
        return(
            <div>
                <label onClick={(event) => this.open_sub(event)}>
                    <img id={linkName+"_btnImg"} src={plusBtn} alt='error'/>
                </label>&ensp;
                <Link className="manual_link" to={to}>{linkName}</Link>
                <div id={linkName+"_div"} className="sub_manual" style={{display:"none"}}>
                    {subList.map( (sub, index) => (
                        <div key={index}>
                            <img src={menIcon} className="icon" alt="error"/>&ensp;
                            <Link className="manual_link" to={sub.link}>{sub.name}</Link><br/>
                        </div>
                    ))}
                </div>
            </div>
        );
    }
}

NavManualLinkSub.propTypes ={
    linkName: PropTypes.string.isRequired,
    to: PropTypes.string.isRequired,
    subList: PropTypes.arrayOf(PropTypes.object).isRequired
}

export default NavManualLinkSub;
